module.exports = __webpack_public_path__ + "static/media/arrowDown.d402fd87.svg";